import {getElementByTagName} from "../utils";

const createArrows = () => {
    const main = getElementByTagName('main');

    for (let item of Array.from(main.childNodes)) {
        if (item.classList.contains('arrowsContainer')) {
            main.removeChild(item);
        }
    }

    const arrowsContainer = document.createElement('div');
    arrowsContainer.classList.add('arrowsContainer');

    const leftArrow = document.createElement('span');
    const rightArrow = document.createElement('span');

    leftArrow.onclick = () => {
        changeImage('-');
    };

    rightArrow.onclick = () => {
        changeImage('+');
    };

    leftArrow.innerText = '<=';
    rightArrow.innerText = '=>';

    leftArrow.title = 'предыдущее фото';
    rightArrow.title = 'следующее фото';

    arrowsContainer.append(leftArrow);
    arrowsContainer.append(rightArrow);

    main.append(arrowsContainer);
};

function changeImage(sign) {
    const images = document.getElementsByClassName('image');
    const arrayOfImages = Array.from(images);

    let currentActive;
    for (let imageId in arrayOfImages) {
        if (!arrayOfImages[imageId].classList.contains('hide')) {
            currentActive = parseInt(imageId, 10);
            break;
        }
    }

    let newActiveIndex;
    if (sign === '+') {
        newActiveIndex = currentActive + 1;

        if (newActiveIndex === arrayOfImages.length) {
            newActiveIndex = 0;
        }
    } else {
        newActiveIndex = currentActive - 1;

        if (newActiveIndex === -1) {
            newActiveIndex = arrayOfImages.length - 1;
        }
    }

    arrayOfImages[currentActive].classList.add('hide');
    arrayOfImages[newActiveIndex].classList.remove('hide');
}

export default createArrows;
